
import { defineComponent, toRefs, reactive, computed, watch } from 'vue'
import Slider from '@/components/top/Slider.vue'
import _ from 'lodash'
import moment from 'moment'
import { useGpvStore } from '@/stores/gpvStore'

export default defineComponent({
  components: {
    Slider,
  },

  setup() {
    const MAX_SLIDER_VALUE = 36
    const MIN_SLIDER_VALUE = 0
    const state = reactive({
      speed: 50,
      autoplay: false,
      sliderValue: 36,
    })

    let timer: number | undefined

    const gpvStore = useGpvStore()
    const baseTime = computed(() => gpvStore.dosha?.baseTime as string)

    const interval = computed(() => (1000 * 100) / state.speed)

    const rainTimeNext = () => {
      state.sliderValue++
      state.sliderValue = _.min([state.sliderValue, MAX_SLIDER_VALUE]) as number
      if (state.sliderValue == MAX_SLIDER_VALUE) {
        state.autoplay = false
      }
      resetTimer()
    }

    const rainTimePrev = () => {
      state.sliderValue--
      state.sliderValue = _.max([state.sliderValue, MIN_SLIDER_VALUE]) as number
      resetTimer()
    }
    const setTimer = () => {
      timer = setTimeout(() => {
        rainTimeNext()
      }, interval.value)
    }
    const resetTimer = () => {
      timer && clearTimeout(timer)
      state.autoplay && setTimer()
    }

    const toggleAutoPlay = () => {
      state.autoplay = !state.autoplay
      if (state.autoplay) {
        rainTimeNext()
        setTimer()
      } else {
        timer && clearTimeout(timer)
      }
    }

    const displayTime = computed(() => {
      const offsetMinute = (state.sliderValue - 36) * 10
      return moment(baseTime.value).add(offsetMinute, 'minute').format('YYYY年MM月DD日 HH:mm')
    })

    const setForecastTime = async () => {
      await gpvStore.fetchTime()

      const offsetMinute = (state.sliderValue - 36) * 10
      gpvStore.setBaseTime(baseTime.value)
      gpvStore.setForcastTime(moment(baseTime.value).add(offsetMinute, 'minute').toISOString())
    }

    watch(() => gpvStore.baseTime, setForecastTime, { immediate: true })

    watch(() => state.sliderValue, setForecastTime, { immediate: true })

    return {
      ...toRefs(state),
      rainTimeNext,
      rainTimePrev,
      toggleAutoPlay,
      displayTime,
      MAX_SLIDER_VALUE,
    }
  },
})
